import React from 'react';
import { connect } from 'react-redux';
import { Accordion, Button, Offcanvas } from 'react-bootstrap';
import _ from 'lodash';
import pluralize from 'pluralize';

import CardDetails from '../../../components/DetailsAccordion/CardDetails';
import { isWhite } from '../../../util/colors';
import { percentileGroupText } from '../../../util/percentileTrends';
import { PERCENTILE_ITEMS_PANEL_WIDTH } from '../CTSPConstants';

import './PercentileItemsPanel.scss';

export class PercentileItemsPanel extends React.Component {
  renderItem(item) {
    const { percentiles, blockedTime, blockers } = this.props;
    const marks = _.filter(item.percentiles, p => _.includes(percentiles, p));

    return (
      <Accordion.Item eventKey={item.card.id} key={item.card.id} className={marks.length ? 'percentile-items-panel__item--marked' : ''}>
        <Accordion.Header>
          <span className={`label_dot ${isWhite(item.color) ? 'label_dot--white' : ''}`} style={{ background: item.color }}></span>
          <span className="percentile-items-panel__name">
            {!!marks.length && <span className="percentile-items-panel__mark">{_.map(marks, p => `${p}%`).join(' and ')}</span>}
            <b>{item.card.name}</b> {item.card.secondaryName}
          </span>
          <span className="percentile-items-panel__days">{pluralize('day', item.days, true)}</span>
        </Accordion.Header>
        <Accordion.Body>
          <CardDetails point={item} blockedTime={blockedTime} blockers={blockers} />
        </Accordion.Body>
      </Accordion.Item>
    );
  }

  render() {
    const { group, onHide } = this.props;
    const { title, aboveRows, belowRows } = percentileGroupText(group);

    return (
      <Offcanvas
        show
        placement="end"
        backdrop={false}
        scroll
        onHide={onHide}
        className="percentile-items-panel"
        style={{ width: PERCENTILE_ITEMS_PANEL_WIDTH }}
      >
        <div className="percentile-items-panel__title">
          <h4>{title}</h4>
          <Button className="btn-action" onClick={onHide}>&times;</Button>
        </div>
        {_.map([...aboveRows, ...belowRows], line => <p key={line}>{line}</p>)}
        <Accordion>
          {_.map(group.items, item => this.renderItem(item))}
        </Accordion>
      </Offcanvas>
    );
  }
}

export const mapStateToProps = state => {
  return {
    percentiles: state.filters.ctsp.selectedPercentiles
  };
};

export default connect(mapStateToProps)(PercentileItemsPanel);
